export const SupplierStatus = {
  PRE_REGISTERED: "pre_registered",
  SENT_TO_REVIEW: "sent_to_review",
  PENDING_PURCHASES: "pending_purchases",
  PENDING_CONTROLLING: "pending_controlling",
  APPROVED: "approved",
  REJECTED: "rejected",
  SUSPENDED_NON_COMPLIANCE: "suspended_non_compliance",
} as const;

export type SupplierStatus =
  (typeof SupplierStatus)[keyof typeof SupplierStatus];

export function formatSupplierStatus(status: SupplierStatus): string {
  switch (status) {
    case SupplierStatus.PRE_REGISTERED:
      return "Pre-registrado";
    case SupplierStatus.SENT_TO_REVIEW:
      return "En revisión";
    case SupplierStatus.PENDING_PURCHASES:
      return "Pendiente de compras";
    case SupplierStatus.PENDING_CONTROLLING:
      return "Pendiente de control";
    case SupplierStatus.APPROVED:
      return "Aprobado";
    case SupplierStatus.REJECTED:
      return "Rechazado";
    case SupplierStatus.SUSPENDED_NON_COMPLIANCE:
      return "Suspendido por incumplimiento";
    default:
      return "Estado desconocido";
  }
}
